import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import "wysihtml5";
import "bootstrap/bootstrap3-wysihtml5";

"use strict";
$.extend($.fn.wysihtml5.defaultOptions, {
    html : true,
    placeholder: false, //insert placeholder code....
    loadfromfile: false,
    loadfromtemplate: false,
    parserRules : $.extend(
        $.fn.wysihtml5.defaultOptions.parserRules || {},{
            tags : $.extend(
                $.fn.wysihtml5.defaultOptions.parserRules.tags || {},{
                    style:{
                        remove:0
                    }
                }
            )
        }
    ),
    stylesheets:[]

});
$.fn.wysihtml5.defaultOptions.parserRules.classes["uly-placeholder"] = 1;
ko.bindingHandlers.richtext = {
    init: function(elt, va, bindings, model, context) {
        $(elt).val(va()());
        $(elt).on("keypress", (ev)=> {
            if ((ev.which || ev.keyCode) == 13) {
                ev.stopPropagation();
                //return false;
            }
        });
        var options = {
            "events": {
                "change": function() {
                    va()($(elt).val());
                },
                "blur": function() {
                    va()($(elt).val());
                },
            },
            "style": true,
            "font-styles": true,
            "emphasis": true,
            "lists": true,
            "html": true,
            "link": true,
            "image": false,
            "color": false,
            parser: function(html) {
                return html;
            }

        };
        var opts =  ko.unwrap(bindings().rich_text_options);
        if (opts) {
            $.extend(options, opts);
        }
        $(elt).wysihtml5(options);

    }

};

ko.bindingHandlers.contentEditable = {
    init: function(elt, va) {
        var obs = va();
        obs._locked = false;
        $(elt).on("input blur keyup", function() {
            if (ko.isWriteableObservable(obs)) {
                obs._locked = true;
                try {
                    var val = elt.innerHTML;
                    if (val === "") val = null;
                    obs(val);
                }
                finally {
                    obs._locked = false;
                }
            }
        });
        elt.innerHTML = ko.unwrap(obs() || "");
    },
    update: function(elt, va, allbindings) {
        var text = ko.unwrap(va());
        var obs = va();
        if (obs._locked)
            return;
        elt.innerHTML = text||"";
    }
};
ko.bindingHandlers.textarea = {
    "init": function(elt, va, allbindings, context, model) {
        let res = ko.bindingHandlers.value.init(elt, va, allbindings, context, model);
        $(elt).on("keypress", (ev)=> {
            if ((ev.which || ev.keyCode) == 13) {
                ev.stopPropagation();
                //return false;
            }
        });
        return res;
    },
    "update": function(elt, va, allbindings, context, model) {
        return ko.bindingHandlers.value.update(elt, va, allbindings, context, model);
    }
};
